"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const material_1 = require("@mui/material");
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const helpers_1 = require("../../../common/helpers/helpers");
const WeatherIcon_1 = __importDefault(require("../../../common/components/Weather/WeatherIcon"));
const HotelViewWrapper = styled_components_1.default.div `
  width: 100%;
  height: 40vh;
  @media (max-width: 500px) {
    height: 30vh;
  }
  position: relative;
  overflow: hidden;
  border-bottom: 1px solid #d5d5d5;
`;
const HotelView = styled_components_1.default.img `
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
const Tint = styled_components_1.default.div `
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  background: rgba(0, 0, 0, 0.1);
`;
const HotelOverview = styled_components_1.default.div `
  position: absolute;
  bottom: 0;
  display: flex;
  width: 100%;
  color: #ffffff;
  align-items: center;
  justify-content: space-between;
`;
const HotelNameOverlay = styled_components_1.default.div `
  padding: 0 24px;
  width: 100%;
  height: 56px;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  bottom: ${(props) => (props.showHotelName ? "0" : "-56px")};
  transition: bottom 0.5s linear;
`;
const HotelName = styled_components_1.default.div `
  max-width: 268px;
  @media (max-width: 375px) {
    max-width: 180px;
  }
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
const WeatherChip = styled_components_1.default.div `
  position: absolute;
  right: 24px;
  width: 80px;
  height: 40px;
  padding: 5px;
  background: rgba(0, 0, 0, 0.502);
  border-radius: 20px;
  display: flex;
  color: #fff;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 0px 5px 0px rgb(0 0 0 / 40%);

  .weather-icon {
    flex-basis: 35px;
    > i {
      display: flex;
      > svg {
        flex-basis: 100%;
      }
    }
  }
`;
const CurrentTemperature = styled_components_1.default.div `
  flex-basis: 40px;
  text-align: center;
`;
const TIME_UNTIL_HOTEL_NAME_IS_HIDDEN = 3000;
const Header = (props) => {
    const { userData: { stays }, } = props;
    const [showHotelName, setShowHotelName] = (0, react_1.useState)(false);
    let hideHotelNameTimer;
    // we store the timeout function in useRef so handleWindowScroll can have the latest updates
    const timerRef = (0, react_1.useRef)({ hideHotelNameTimer });
    const tripInfo = stays && stays[0];
    const countDownDays = tripInfo &&
        Math.ceil(helpers_1.Helpers.getDaysBetweenDates(new Date(), new Date(tripInfo.startsOn)));
    const tripInteval = tripInfo &&
        `${helpers_1.Helpers.getDateFromString(tripInfo.startsOn)} - ${helpers_1.Helpers.getDateFromString(tripInfo.endsOn)}`;
    const functionalityForShowVenueName = () => {
        setShowHotelName(true);
        clearTimeout(timerRef.current.hideHotelNameTimer);
        timerRef.current.hideHotelNameTimer = setTimeout(() => {
            if (setShowHotelName) {
                setShowHotelName(false);
            }
        }, TIME_UNTIL_HOTEL_NAME_IS_HIDDEN);
    };
    const showVenueNameAppIsOpen = () => {
        functionalityForShowVenueName();
    };
    const handleWindowScroll = () => {
        if (window.pageYOffset === 0) {
            functionalityForShowVenueName();
        }
    };
    (0, react_1.useEffect)(() => {
        window.addEventListener("scroll", handleWindowScroll, {
            passive: true,
        });
        showVenueNameAppIsOpen();
        return () => {
            window.removeEventListener("scroll", handleWindowScroll, {
                passive: true,
            });
        };
    }, []);
    const handleImageClick = () => {
        if (!showHotelName) {
            clearTimeout(timerRef.current.hideHotelNameTimer);
            setShowHotelName(true);
            timerRef.current.hideHotelNameTimer = setTimeout(() => {
                if (setShowHotelName) {
                    setShowHotelName(false);
                }
            }, TIME_UNTIL_HOTEL_NAME_IS_HIDDEN);
        }
    };
    return (react_1.default.createElement(HotelViewWrapper, { onClick: handleImageClick },
        react_1.default.createElement("picture", null,
            react_1.default.createElement("source", { media: "(max-width: 600px)", srcSet: props.hotelView.L }),
            react_1.default.createElement(HotelView, { src: props.hotelView.XXL })),
        react_1.default.createElement(Tint, null),
        props.withWeatherData && props.weatherData && (react_1.default.createElement(HotelOverview, null,
            react_1.default.createElement(HotelNameOverlay, { showHotelName: showHotelName },
                react_1.default.createElement(HotelName, null, document.title),
                react_1.default.createElement(material_1.Typography, null, tripInfo &&
                    window.location.pathname === `/${tripInfo.venue.slug}` &&
                    countDownDays <= 30 &&
                    countDownDays >= 0 &&
                    tripInteval)),
            props.weatherData.current && (react_1.default.createElement(WeatherChip, { id: "aqa_homepage_weatherchip" },
                react_1.default.createElement(WeatherIcon_1.default, { symbol: props.weatherData.current.symbol, whiteTransparentVariant: true }),
                react_1.default.createElement(CurrentTemperature, null,
                    `${props.weatherData.current.temperature}`,
                    "\u00B0")))))));
};
exports.Header = Header;
const mapStoreToProps = (store) => ({
    hotelView: store.getValue("hotelView"),
    weatherData: store.getValue("weather"),
    userData: store.getValue("userData"),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(exports.Header);
